export enum OrderByValue {
  ASC = 'ASC',
  DESC = 'DESC',
}

export const ORDER_BY_VALUE = Object.values(OrderByValue);
